import React, { useState } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import AsyncSelect from "react-select/async";
import { API } from "@aws-amplify/api";
import { selectDefaultStyle } from "styles/selectDefaultStyle";
import { customerByBusinessByPhone } from "graphql/queries";
import { Actions as ACTIONS } from "store/customer/action";
import { Actions as NOTIFICATIONACTIONS } from "store/notifications/action";
import MultiInputTag from "../MultiInputTag";

const IndicatorsContainer = () => (
  <div style={{ display: "flex", padding: "6.5px" }}>
    <svg className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
      <path
        fillRule="evenodd"
        d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
        clipRule="evenodd"
      />
    </svg>
  </div>
);

const CouponCustomers = ({
  customers,
  businessID,
  coupon,
  saveCouponToCustomer,
  addNotification,
  bulkSaveCouponToCustomer,
}) => {
  const [customerToAdd, setCustomerToAdd] = useState(null);
  const [loading, setLoading] = useState(false);
  const [isBulkInsert, setIsBulkInsert] = useState(false);
  const [bulkInsertPhoneNumbers, setItemBulkInsertPhoneNumbers] = useState([]);
  const bulkInsertLimit = 100;

  const validateSelectedCustomer = (customerCoupons) => {
    const isCouponAlreadySelected = customerCoupons?.items?.find(
      (item) => item.coupon?.id === coupon.id && !item._deleted
    );
    if (isCouponAlreadySelected) {
      addNotification(
        {
          title: (
            <React.Fragment>
              <strong>Warning</strong>{" "}
            </React.Fragment>
          ),
          message: `Coupon already added.`,
          icon: `warning`,
        },
        5000
      );
      return false;
    }
    return true;
  };

  const addCouponToCustomer = async () => {
    const customerCoupon = {
      couponID: coupon.id,
      customerID: customerToAdd.id,
    };
    await saveCouponToCustomer(customerCoupon, coupon, customerToAdd);
    setCustomerToAdd(null);
  };

  const addCouponToCustomerBulk = async () => {
    setLoading(true);
    await bulkSaveCouponToCustomer(bulkInsertPhoneNumbers, coupon.id);
    setLoading(false);
  };

  return (
    <div className="max-w-7xl mx-auto">
      <div className="flex flex-col">
        <div className="-my-2 py-2 overflow-x-auto sm:-mx-6 sm:px-6 lg:-mx-8 lg:px-8">
          <div className="align-middle inline-block min-w-full shadow overflow-hidden sm:rounded-lg border-b border-gray-200">
            <table className="min-w-full">
              <thead>
                <tr>
                  <th
                    colSpan={3}
                    className="px-6 py-3 text-left text-xs leading-4 font-medium bg-gray-50 text-indigo-500 cursor-pointer"
                    onClick={() => setIsBulkInsert(!isBulkInsert)}
                  >
                    {!isBulkInsert ? "Add Corporate" : "Add coupon to customer"}
                  </th>
                </tr>
                {isBulkInsert ? (
                  <tr>
                    <th
                      colSpan={3}
                      className="px-6 py-3 border-b border-gray-200 bg-gray-50 leading-4 font-medium text-gray-500"
                    >
                      <div className="flex items-end">
                        <div className="col w-full text-left">
                          <div className="mb-1 font-bold">Instructions:</div>
                          <div className="mb-1">
                            1. Enter only the digits of the phone numbers,
                            separated by commas (e.g., "35699000000,
                            35699000001, 35699000002").
                          </div>
                          <div className="mb-1">
                            2. Press Enter when you're done.
                          </div>
                          <div className="mb-1">
                            3. If a phone number is highlighted in red,
                            double-check it for accuracy.
                          </div>
                          <div className="mb-2">
                            4. You can add up to {bulkInsertLimit} phone numbers
                            at a time.
                          </div>
                          <MultiInputTag
                            onItemsChange={(items) =>
                              setItemBulkInsertPhoneNumbers(items)
                            }
                            limit={bulkInsertLimit}
                          />
                        </div>
                        <button
                          disabled={
                            bulkInsertPhoneNumbers?.length === 0 || loading
                          }
                          onClick={(e) => {
                            e.preventDefault();
                            e.stopPropagation();
                            addCouponToCustomerBulk();
                          }}
                          className={`ml-2 py-2 px-3 border border-transparent text-sm font-medium rounded-md text-white ${
                            bulkInsertPhoneNumbers?.length === 0 || loading
                              ? "bg-gray-300 cursor-not-allowed"
                              : "bg-indigo-600 hover:bg-indigo-500"
                          }`}
                        >
                          {loading ? "Loading..." : "Add"}
                        </button>
                      </div>
                    </th>
                  </tr>
                ) : (
                  <tr>
                    <th
                      colSpan={3}
                      className="px-6 py-3 border-b border-gray-200 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 tracking-wider"
                    >
                      <div className="flex">
                        <AsyncSelect
                          className="block form-select w-full p-0 border border-gray-300 bg-white rounded-md shadow-sm focus:outline-none focus:shadow-outline-blue focus:border-blue-300 transition duration-150 ease-in-out sm:text-sm sm:leading-5"
                          styles={selectDefaultStyle}
                          defaultOptions={[]}
                          loadOptions={(inputValue, callback) => {
                            const beginsWith =
                              inputValue.substr(0, 1) == "+"
                                ? inputValue
                                : inputValue.substr(0, 2) == "00"
                                ? `+${inputValue.substr(2)}`
                                : `+356${inputValue}`;

                            const variables = {
                              phone: { beginsWith },
                              businessID,
                              filter: { active: { ne: false } },
                            };
                            const request = API.graphql({
                              query: customerByBusinessByPhone,
                              variables,
                              authMode: "AMAZON_COGNITO_USER_POOLS",
                            });

                            request.then(({ data }) => {
                              const customers =
                                data.customerByBusinessByPhone.items.filter(
                                  (item) => item._deleted != true
                                );

                              const options =
                                customers &&
                                customers.map((customer) => ({
                                  value: customer,
                                  label: `${customer.givenName} ${customer.familyName} (${customer.phone})`,
                                }));

                              callback(options);
                            });
                          }}
                          placeholder="Find client..."
                          onChange={(selectedCustomer) => {
                            setCustomerToAdd(null);
                            const isValid = validateSelectedCustomer(
                              selectedCustomer.value.coupons
                            );
                            if (isValid)
                              setCustomerToAdd(selectedCustomer.value);
                          }}
                          components={{ IndicatorsContainer }}
                        />
                        <button
                          onClick={(e) => {
                            e.preventDefault();
                            e.stopPropagation();
                            addCouponToCustomer();
                          }}
                          disabled={!customerToAdd}
                          className={`ml-2 py-1 px-2 border border-transparent text-sm font-medium rounded-md text-white ${
                            !customerToAdd
                              ? "bg-gray-300 cursor-not-allowed"
                              : "bg-indigo-600 hover:bg-indigo-500"
                          }`}
                        >
                          Add
                        </button>
                      </div>
                    </th>
                  </tr>
                )}
                <tr>
                  <th className="px-6 py-3 border-b border-gray-200 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider">
                    NAME
                  </th>
                  <th className="px-6 py-3 border-b border-gray-200 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider">
                    PHONE
                  </th>
                  <th className="px-6 py-3 border-b border-gray-200 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider"></th>
                </tr>
              </thead>
              <tbody className="bg-white">
                {customers?.length === 0 && (
                  <tr>
                    <td
                      colSpan={4}
                      className="px-6 py-4 text-center border-b border-gray-200 text-sm leading-5 text-gray-500"
                    >
                      No customer possesses this coupon
                    </td>
                  </tr>
                )}
                {customers?.map((item) => (
                  <tr key={item.customer.id}>
                    <td className="px-6 py-4 whitespace-no-wrap border-b border-gray-200 text-sm leading-5 font-medium text-gray-900">
                      {item.customer.givenName} {item.customer.familyName}
                    </td>
                    <td className="px-6 py-4 whitespace-no-wrap border-b border-gray-200 text-sm leading-5 text-gray-500">
                      {item.customer.phone}
                    </td>
                    <td className="px-6 py-4 whitespace-no-wrap border-b border-gray-200 text-sm leading-5 text-gray-500">
                      <Link
                        to={`/customer/${item.customer.id}`}
                        className="text-indigo-600 hover:text-indigo-900 focus:outline-none focus:underline"
                      >
                        Edit
                      </Link>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  const customers =
    state.coupon?.item?.customers?.items?.filter((item) => item.customer) || [];
  return {
    customers,
    businessID: state.businessID,
    coupon: state.coupon?.item,
  };
};

const mapDispatchToProps = (dispatch) => ({
  saveCouponToCustomer: (item, coupon, customer) =>
    dispatch(ACTIONS.saveCouponToCustomer(item, coupon, customer)),
  addNotification: (notification, removeAfter) =>
    dispatch(NOTIFICATIONACTIONS.addNotification(notification, removeAfter)),
  bulkSaveCouponToCustomer: (phoneNumbers, couponID) =>
    dispatch(ACTIONS.bulkSaveCouponToCustomer(phoneNumbers, couponID)),
});

export default connect(mapStateToProps, mapDispatchToProps)(CouponCustomers);
